export default {
  "banner": {
    "text": "了解详情 ",
    "link": "#solution"
  },
  "summit": {
    "title": {
      "mainTitle": "2020 Google 游戏开发者峰会",
      "subTitlePC": "Google 游戏开发者峰会是游戏行业最重要的专业盛会，旨在鼓励游戏开发人员并提高其技术水平。对于 Google 来说，今年虽然没有办法在线下与开发者互动，在线上，Google 仍然为开发者们呈现了一场特殊的峰会。北京时间 3 月 24 日早 9:00，Google 通过国内几大直播平台为开发者在线直播了中文主题演讲，分享了 Mobile、云计算、Stadia 三大板块的技术实践与创新能力。",
      "subTitleMobile": "Google 游戏开发者峰会是游戏行业最重要的专业盛会，旨在鼓励游戏开发人员并提高其技术水平。北京时间 3 月 24 日早 9:00，Google 通过国内几大直播平台为开发者在线直播了中文主题演讲，分享了 Mobile、云计算、Stadia 三大板块的技术实践与创新能力。"
    },
    "leftList": [
      {
        "title": "2020 Google 游戏开发者峰会盘点",
        "text": "虽然无法与开发者们现场交流，Google 游戏开发者峰会以免费在线直播的形式与大家云见面，分享了行业前沿的技术更新和精彩纷呈的产品应用。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/11/d1/11ea74e6ad68b489244bcaca0f3253d1.png",
        "link": "https://mp.weixin.qq.com/s/-9sIWRfKLTa1K74XLuN2tw",
        "target": "_blank"
      },
      {
        "title": "带你走进云时代的游戏变革",
        "text": "本次 Google 游戏开发者峰会上推出了 Stadia Makers，被称为是 Google 为有经验的独立游戏开发人员扩展自主发行的第一步。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/cf/20/cf91b39ef41056d9135c48284e960520.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/iGrvHxv68YFyhrGNMtdA",
        "target": "_blank"
      },
      {
        "title": "通过 Game Servers 和 Agones 进行全球扩展",
        "text": "Game Servers 提供了一个易于自动化的管理层来协调您分布在全球的 Agones 集群，同时它秉承开源理念从而为客户保证灵活性。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/b2/c6/b262d7afac230b82cdfd61c7d27deec6.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/BodeaHBP4OLYPfb5RP8V",
        "target": "_blank"
      },
      {
        "title": "通过 Open Match 简化多人匹配并进行扩展",
        "text": "在这一主题下，讨论了在多人游戏中的对战匹配问题，以及Google Cloud 和 Unity 共同创建的开源匹配框架 Open Match 的作用。了解日本游戏工作室 Grenge 在他们最新的 4V4 实时多人游戏《Kick-Flight》中使用 Open Match 的体验。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/54/cd/5414e96d183cc685623f623d2ef335cd.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/HIiM4dAwfAWDpt35lwLU",
        "target": "_blank"
      },
      {
        "title": "使用 Unity 和 Google Cloud 进行游戏模拟",
        "text": "在这一主题下，讨论了测试游戏平衡的问题，以及新发布的 Unity Game Simulation 游戏模拟功能是怎样的。Furyion Games 作为首批通过在线多人射击游戏测试 Unity Game Simulation 的公司之一，有哪些经验之谈？",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/0d/ab/0dd1161c865ee05ec05f885999ea8eab.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/64YjWvB6AkreosxlKKAH",
        "target": "_blank"
      },
      {
        "title": "《Dragon Quest Walk》游戏如何处理数百万玩家",
        "text": "在这一主题下，讨论了在日本《Dragon Quest Walk》手游为什么选择 Cloud Spanner，以及如何将其与 Google Cloud 的其它服务相结合。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/cc/ee/cc0a7597f806feb95347222f3abeafee.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/KeCFrgZYRJUZ36JcSm8L",
        "target": "_blank"
      },
      {
        "title": "基于 Google Cloud 构建游戏在线分析系统",
        "text": "在这一主题下，讨论了 Improbable 如何为开发人员提供一种灵活的方式来构建、托管和自定义基于 Google Cloud 产品（例如 GCS，Dataflow 和 BigQuery）的游戏在线分析服务。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/7b/62/7bf3b9429f1ea347812bf966482a3962.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/Ieyi41mMOUZk8WCUfMOO",
        "target": "_blank"
      }
    ],
    "rightList": [
      "https://static001-test.geekbang.org/resource/image/e0/0d/e003d1a20ebfd9a38584a820ab36df0d.png",
      "https://static001-test.geekbang.org/resource/image/99/aa/99e0360481b9849fa0e2ec0cca3664aa.png",
      "https://static001-test.geekbang.org/resource/image/f3/a2/f3cecc902a3531ab31a29e2b46b3bba2.png"
    ]
  },
  "challenge": {
    "title": {
      "mainTitle": "游戏开发挑战",
      "subTitle": "充分利用 Google 的云计算服务, 着力应对业务挑战"
    },
    "list": [
      {
        "title": "游戏部署",
        "text": "基础架构部署和管理复杂，且无法根据游戏热度增加或减少快速实现弹性伸缩。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/20/24/20182caf7d5900ccd733fa8d7d31f224.png",
        "style": "width: 38px; vertical-align: -4.5px;"
      },
      {
        "title": "平台服务",
        "text": "大规模对战匹配开发耗时费力，且难以专注于游戏逻辑本身。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/3d/56/3dff28d5b4814e103f3fbf2699c81f56.png",
        "style": "width: 38px; vertical-align: -6px;"
      },
      {
        "title": "游戏分析",
        "text": "PB 级数据的管理和分析难度大、成本高，难以有效形成游戏价值链。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/0e/16/0edbedfd35a1c33fe11ac282af84bb16.png",
        "style": "width: 23px; vertical-align: -8px;"
      }
    ]
  },
  "solution": {
    "title": {
      "mainTitle": "解决方案",
      "subTitle": "最大限度地降低基础架构复杂性, 助力开发者打造出色的游戏体验"
    },
    "technical": [
      {
        "category": "技术文章",
        "title": "在 Kubernetes Engine 中运行专用游戏服务器",
        "text": "将服务器应用打包为容器映像的做法迅速风靡了整个技术领域。此外，许多游戏公司还对使用容器提高虚拟机利用率感兴趣，并利用容器提供的独立运行时范式。虽然兴趣浓厚，但很多游戏公司不知道从何入手。我们建议使用容器编排框架 Kubernetes 来部署生产规模的专用游戏服务器。",
        "sign": "游戏部署",
        "link": "https://www.infoq.cn/zones/google/cloud/article/DlFr62bs7m4xVPWINpbh"
      },
      {
        "category": "技术文章",
        "title": "Open Match：灵活且可扩展的游戏匹配解决方案",
        "text": "如果能够让游戏开发人员专注于游戏匹配逻辑（让技术水平相近的玩家们同组对抗），帮助他们摆脱从零开始为每款游戏构建匹配机制的糟糕体验，又会如何？",
        "sign": "平台服务",
        "link": "https://www.infoq.cn/zones/google/cloud/article/c6gzKHtgYbAEJmFpftb7"
      },
      {
        "category": "技术文章",
        "title": "构建移动游戏分析平台",
        "text": "移动游戏应用生成大量的玩家遥测和游戏事件数据。这些数据有可能提供有关玩家行为及其与游戏互动的数据分析。移动游戏的本质，即大量客户端设备、不规则和慢速的互联网连接、电池和电源管理问题等意味着玩家遥测和游戏事件分析面临着独特的挑战。",
        "sign": "游戏分析",
        "link": "https://www.infoq.cn/zones/google/cloud/article/pVLWDhwrT0cxEubTxVxa"
      },
      {
        "category": "技术文章",
        "title": "使用 Cloud SQL for MySQL Second Generation 作为移动游戏后端数据库",
        "text": "对于基本的基于会话的游戏，最终比赛结果是数据库存储的最复杂的数据。对于大型、永久世界 (persistent-world) 和大型多人在线 (MMO) 游戏，数据库可能要存储一组相互关联的表格，用于记录玩家进度和库存。后端数据库层中的查询速度会直接影响用户在游戏客户端上的响应体验。",
        "sign": "游戏部署",
        "link": "https://www.infoq.cn/zones/google/cloud/article/jFbmP7z6UXOWqDtcW4XD"
      },
      {
        "category": "技术文章",
        "title": "专用游戏服务器迁移指南",
        "text": "本文讨论将计算机游戏服务器迁移到 Google Cloud Platform (GCP) 的注意事项。",
        "sign": "游戏部署",
        "link": "https://www.infoq.cn/zones/google/cloud/article/6wMwgyhJGylJwKgBfBF6"
      },
      {
        "category": "技术文章",
        "title": "利用 Memorystore for Redis 创建游戏排行榜",
        "text": "本教程将向您展示如何利用 Memorystore for Redis，构建起运行在 Google Kubernetes Engine（GKE）之上的ASP.NET排行榜应用程序。随后，我们还将通过一款JavaScript示例游戏演示如何发布并检索分数。本教程适用于希望在云端运行游戏排行榜的开发人员群体。",
        "sign": "平台服务",
        "link": "https://www.infoq.cn/zones/google/cloud/article/0pK0lghgroDGCOh13vFz"
      }
    ],
    "client": [
      {
        "category": "客户案例",
        "title": "《七龙珠：武斗传奇》与 Google Cloud Platform 后端",
        "text": "作为万代南梦宫娱乐公司（BNE）打造的一款全新手机游戏，《七龙珠：武斗传奇》基于公司旗下广受好评的“龙珠 Z”系列作品，目前已经向全球玩家正式开放。为了做好准备以飨玩家服务，BNE 早在 2017 年 2 月就开始与 Google Cloud 沟通，探讨这款游戏可能面临的种种挑战，希望 Google 方面能够提供足以应对各类实际负载难题的强大云基础设施。",
        "link": "https://www.infoq.cn/zones/google/cloud/article/ysWyM4ISfRvqoyMtr7Xr"
      },
      {
        "category": "客户案例",
        "title": "绿洲游戏：在高性能云平台上为游戏提供动力",
        "text": "绿洲游戏一直在用云服务来减轻自己的基础设施成本，并且针对不同国家和地区测试了多个云服务提供商的服务，其中 Google Cloud Platform 凭借出色的性价比、可靠性以及出色的自动化运维赢得了绿洲游戏的青睐。",
        "link": "https://www.infoq.cn/zones/google/cloud/article/GGo4kPsdGDIPaS5PRgPv"
      },
      {
        "category": "客户案例",
        "title": "ELEX：为数十万并发聊天用户提供支持",
        "text": "在 Google Compute Engine 与 Google Cloud Translation API 的双重助力之下，ELEX 公司构建起一套全球聊天服务系统。这项服务，也成为该公司旗下大型多人在线战略游戏《列王的纷争》大获成功的关键所在。",
        "link": "https://www.infoq.cn/zones/google/cloud/article/aaBaSCcKv1Brl31a70yj"
      }
    ],
    "video": [
      {
        "category": "视频案例",
        "title": "在 Google Cloud Platform 上构建游戏",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/25/79/259f6f26efa120086e2cb1b9da5cde79.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/aNqW3ykhqKxTjF5uLR23"
      },
      {
        "category": "视频案例",
        "title": "Google Cloud 助力 Pocket Gems",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/39/b2/3955ba4f23d5369bffabf037bc3805b2.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/flvJT26cwif8zYqZFwFL"
      },
      {
        "category": "视频案例",
        "title": "Apex Legends 如何借助 Google Cloud 在 1 个月内覆盖 5 千万玩家",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/6e/e5/6ea589da759d9a2880298fff4abff8e5.png",
        "link": "https://www.infoq.cn/zones/google/cloud/article/rveE8f4YCobuohdKuNwo"
      }
    ]
  },
  "share": [
    {
      "imageList": "https://static001-test.geekbang.org/resource/image/99/2a/99cc4e916e0aa31b8f9fb4bf607f1b2a.png",
      "textInfo": {
        "top": {
          "mainTitle": "交流分享",
          "subTitle": "与专家交流互动, 并了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "出海纪 | Google Cloud 今日谈 <br> 对话网易游戏：出海背后的技术密码",
          "time": "2020年4月9日",
          "address": "线上分享",
          "text": "技术在游戏研发过程中起到很大的推动力，是游戏质量的保证，2020 年，出海仍然是中国游戏厂商绕不开的话题，技术突围也必将是厂商关注的重点。来自 Google Cloud 的技术工程师和网易游戏的架构师通过对话的方式来分享网易游戏的出海经验以及 Google Cloud 的技术赋能。"
        }
      },
      "button": {
        "link": "https://uao.so/swwTQwZeoje",
        "text": "查看活动"
      }
    },
    {
      "imageList": "https://static001-test.geekbang.org/resource/image/95/f0/950e5945901e702687bd5ac4afe5bef0.png",
      "textInfo": {
        "top": {
          "mainTitle": "交流分享",
          "subTitle": "与专家交流互动, 并了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "通过 Anthos 在混合环境中部署多人游戏",
          "time": "2020年3月19日",
          "address": "线上分享",
          "text": "很多大型游戏，都需要采用云服务，来实现服务器按需扩容、数据分析、安全监控等功能。Google Cloud 针对游戏行业的痛点,推出了多项基于 Kubernetes 技术的平台服务和工具组件。其中 Anthos 提供了一整套解决方案，帮助游戏开发商，快速实现数据中心和私有部署。"
        }
      },
      "button": {
        "link": "http://cms.hftty.cn/live/detail/id/134.html?traincode=infoq",
        "text": "查看活动"
      }
    }
  ]
}
